import {
  DataItem,
  HexInjectedSolanaSigner,
  InjectedSolanaSigner,
} from '@dha-team/arbundles/web';
import type { TurboSolanaSignerMode, TurboSolanaWalletAdapter } from './wallet';

export function createTurboSolanaSigner(
  walletAdapter: TurboSolanaWalletAdapter,
  mode: TurboSolanaSignerMode = 'hex',
) {
  return mode === 'raw'
    ? new InjectedSolanaSigner(walletAdapter)
    : new HexInjectedSolanaSigner(walletAdapter);
}

export async function verifyTurboSignedDataItem(
  signedBytes: Uint8Array,
): Promise<boolean> {
  return DataItem.verify(Buffer.from(signedBytes));
}
